"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnOptionsMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var BigCheckList_1 = require("../../molecules/BigCheckList");
var SortOptions_1 = require("../../molecules/SortOptions");
var DateRange_1 = require("../../molecules/DateRange");
var utils_1 = require("../../utils");
exports.ColumnOptionsMenu = react_1.default.memo(react_1.default.forwardRef(function (_a, ref) {
    var idPrefix = _a.idPrefix, sort = _a.sort, listFilter = _a.listFilter, dateFilter = _a.dateFilter, onClickAway = _a.onClickAway, _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.menuSize, menuSize = _c === void 0 ? null : _c, rest = __rest(_a, ["idPrefix", "sort", "listFilter", "dateFilter", "onClickAway", "open", "menuSize"]);
    // the guts of the component
    var children = ((0, jsx_runtime_1.jsx)(core_1.Popover, __assign({ open: open, role: "menu" }, rest, { ref: ref, PaperProps: {
            style: {
                width: menuSize && utils_1.columnMenuSizeMap[menuSize] ? utils_1.columnMenuSizeMap[menuSize] : 'auto',
            },
        } }, { children: (0, jsx_runtime_1.jsx)(core_1.Card, { children: (0, jsx_runtime_1.jsxs)(core_1.CardContent, __assign({ role: "menu" }, { children: [sort && (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ my: 1 }, { children: sort && (0, jsx_runtime_1.jsx)(SortOptions_1.SortOptions, __assign({}, sort, { idPrefix: idPrefix })) })), dateFilter && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ my: 1 }, { children: (0, jsx_runtime_1.jsx)(DateRange_1.DateRange, __assign({}, dateFilter, { idPrefix: idPrefix })) }))), listFilter && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ my: 1 }, { children: (0, jsx_runtime_1.jsx)(BigCheckList_1.BigCheckList, __assign({}, listFilter, { idPrefix: idPrefix })) })))] })) }) })));
    // TODO: remove this as popover handles its own click away listener
    return onClickAway ? (
    // wrap in listener if we provide a function
    (0, jsx_runtime_1.jsx)(core_1.ClickAwayListener, __assign({ onClickAway: onClickAway }, { children: children }))) : (children);
}));
